module.exports = __webpack_public_path__ + "img/invite_bg.9aa6847d.png";